import humanizeString from 'humanize-string'

import { DotRatings } from '../../../../DotRatings'
import { CategoryReview } from '../../../../ReviewCard/ReviewCard.types'
import { DetailedReview } from '../../DetailedReview'
import * as S from '../Review.styles'
import { hasTagsOrComments, labelByReviewCategory } from '../Review.utils'

interface DetailedReviewsProps {
  reviewId: string
  categoryReviews?: CategoryReview[]
}

export const DetailedReviews = ({ reviewId, categoryReviews }: DetailedReviewsProps) => {
  if (!categoryReviews?.length) return null

  if (hasTagsOrComments(categoryReviews)) {
    return (
      <S.DetailedRatingsColumnsContainer>
        {categoryReviews.map(review => (
          <DetailedReview
            key={`detailed-rating-${reviewId}-${review.category}`}
            reviewDetail={review}
          />
        ))}
      </S.DetailedRatingsColumnsContainer>
    )
  }

  return (
    <S.DetailedRatingsRowContainer>
      {categoryReviews.map(review => (
        <DotRatings
          key={`detailed-rating-${reviewId}-${review.category}`}
          shouldHideProgressBar
          shouldShowMaxRating
          isSubRating
          rating={review.rating}
          category={labelByReviewCategory[review.category] ?? humanizeString(review.category)}
        />
      ))}
    </S.DetailedRatingsRowContainer>
  )
}
